<template>
  <div class="container-fluid">
    <div class="vld-parent row pb-4 pr-0" :class="deploymentBgClass" :id="$id('calendar')" ref='calendarContainer'>

      <div
        class="col px-0 calendarWeekGrid"
        :id="$id('mainCal')">
        <div :class="($mq == 'sm' || $mq == 'xs') ? 'container-fluid px-0' : 'container px-0'">
          <div class="bgDarker">
            <div class="row pt-4">
              <div class="col text-center">
                <h2 class="font-weight-bold calendarWeekGrid_Header_Title">
                  <template v-if="axeThrowing">
                    Available Axe Throwing At {{ location.name }}
                  </template>
                  <template v-if="$deploymentIs('operationescape')">
                    Booking opening soon&hellip;
                  </template>
                  <template v-else>
                    Available Games for {{ room.name }}
                  </template>
                </h2>
              </div>
            </div>

            <booking-calendar-sub-component-date-selection-header
              :date="date"
              :date-selection-display-day="false"
              @date-changed-on-header="changeDate"
              ></booking-calendar-sub-component-date-selection-header>

            <table class="calendarWeekGrid_table">
              <thead>
                <tr class="text-center">
                  <th v-for="(date, key) in dateRange" :key="key" class="pt-0">
                    <span class="calendarWeekGrid_Header calendarWeekGrid_Header_Date">{{ date | moment('DD') }}</span>

                    <mq-layout :mq="['xs', 'sm']">
                      <span class="calendarWeekGrid_Header calendarWeekGrid_Header_Month">{{ date | moment('MMM') }}</span>
                    </mq-layout>
                    <mq-layout mq="md+">
                      <span class="calendarWeekGrid_Header calendarWeekGrid_Header_Month">{{ date | moment('MMMM') }}</span>
                    </mq-layout>

                    <mq-layout mq="md+">
                      <hr class="my-1" style="border-top: 4px double rgba(204, 204, 204, 0.8);">
                    </mq-layout>

                    <mq-layout :mq="['xs', 'sm']">
                      <span class="calendarWeekGrid_Header calendarWeekGrid_Header_Day">{{ date | moment('ddd') }}</span>
                    </mq-layout>
                    <mq-layout mq="md+">
                      <span class="calendarWeekGrid_Header calendarWeekGrid_Header_Day">{{ date | moment('dddd') }}</span>
                    </mq-layout>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="roomSlotIndex in range(0, (maximumSlotsInAnyDayThisWeekForRoom - 1))">
                  <tr class="calendarWeekGrid_Row7Day">
                    <template v-for="(date, key) in dateRange">
                      <td
                        v-if="roomSlotsForRoom[date.format('YYYY-MM-DD')] && roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex] && now.isSameOrBefore(roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex].start)"
                        :class="calendarCell(date.format('YYYY-MM-DD'), roomSlotIndex).class"
                        @click.prevent="roomSlotClicked(roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex])">

                        <span class="calendarWeekGrid_Cell calendarWeekGrid_Cell_Time">
                          {{ roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex].start | moment('h:mm') }}
                          <small>{{ roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex].start | moment('a') }}</small>
                        </span>

                        <span class="calendarWeekGrid_Cell calendarWeekGrid_Cell_Availability" v-html="calendarCell(date.format('YYYY-MM-DD'), roomSlotIndex).text"></span>
                      </td>
                      <td v-else>
                        <span class="material-icons" :class="$deploymentIs('escapable') ? 'text-white' : ''">block</span>
                      </td>
                    </template>
                  </tr>
                </template>
                <tr v-if="maximumSlotsInAnyDayThisWeekForRoom"><!-- row for games available in other Rooms -->
                  <template v-for="(date, key) in dateRange">
                    <td
                      v-if="now.isSameOrBefore(date, 'day') && otherRoomsAvailableForWeek[date.format('YYYY-MM-DD')] && otherRoomsAvailableForWeek[date.format('YYYY-MM-DD')].length"
                      class="calendarWeekGrid_Other_Games">
                      <div class="btn-group-vertical">
                        <a
                          v-for="room_id in otherRoomsAvailableForWeek[date.format('YYYY-MM-DD')]"
                          :href="locationRoomRoute(room_id, date.format('YYYY-MM-DD')) + '#book'"
                          :class="'btn btn-' + location.rooms.find(room => room.id == room_id).nickname"
                          @click.prevent="otherRoomClicked(location.rooms.find(room => room.id == room_id))">
                          {{ ($mq === 'sm' || $mq === 'xs') ? (location.rooms.find(room => room.id == room_id).short ? location.rooms.find(room => room.id == room_id).short : (location.rooms.find(room => room.id == room_id).slug.charAt(0).toUpperCase() + location.rooms.find(room => room.id == room_id).slug.slice(1)).replace(/-/g, '').substring(0,5)) : location.rooms.find(room => room.id == room_id).name }}
                        </a>
                      </div>
                    </td>
                    <td v-else class="calendarWeekGrid_Other_Games">
                      No other available Games
                    </td>
                  </template>
                </tr>
                <tr v-else>
                  <td colspan="7" class="calendarWeekGrid_footer_row">
                    <p class="no-slots-text">
                      There are currently no RoomSlots set up for this time period.
                      <span v-if="$deploymentIs('cryptology')" class="font-weight-bold"><br>Cryptology is closed on a Tuesday. With advanced notice we may be able to secure you a booking.</span>
                    </p>
                    <template v-if="$deploymentIs('escapable')">
                      <p>This is because this month's slots have already been released/sold or have yet to be released. Slots for The Great Loudini - Live Magic & Puzzles edition are released monthly.</p>
                      <p>For example, slots for January will open around December 1st. Please note, we cannot accept advance bookings beyond the monthly schedule we release.</p>
                    </template>
                    <p v-if="$deploymentIs('horrorescape')">
                      Please email the branch at <a :href="'mailto:' + location.email + '?subject=Enquiry about future availability'" class="text-white font-weight-bold">{{ location.email }}</a>
                    </p>
                    <p v-else-if="$deploymentIs('topescaperooms')"></p>
                    <p v-else>
                      Please contact the branch on <a :href="'tel:' + location.telephone" class="text-white font-weight-bold">{{ location.telephone }}</a> or email <a :href="'mailto:' + location.email + '?subject=Enquiry about future availability'" class="text-white font-weight-bold">{{ location.email }}</a>
                    </p>
                  </td>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th class="calendarWeekGrid_Footer_Heading_Cell" colspan="7">
                    <label class="mb-0" v-html="">Click to see other rooms with availability &uarr;</label>
                    <br>
                    <label class="mb-0" v-html="">Click to see all experiences on this day &darr;</label>
                  </th>
                </tr>
                <tr class="text-center">
                  <td colspan="7">
                    <button class="btn btn-lg btn-tempus-blue-500" @click.prevent="allRoomsClicked">
                      All Games On This Date
                    </button>
                  </td>
                </tr>
              </tfoot>

            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialCart: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    bookingRoomId: {
      type: Number,
      default: null,
    },
    mainroomRoomId: {
      type: Number,
      default: null,
    },
    date: {
      type: Object,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'R',
    },
    locationDiscount: {
      type: Object,
    },
    roomSlots: {
      type: [Object, Array],
    },
    roomsAvailable: {
      type: [Object, Array],
    },
    brand: {
      type: String,
    },
    maxPerRow: {
      type: Number,
      default: 5,
    },
    locationChildPricing: {
      type: Boolean,
    },
    adultPricingNotPlayerPricing: {
      type: Boolean,
    },
    customerRequestMarketingPermission: {
      type: Boolean,
    },
    axeThrowing: {
      type: Boolean,
      default: false,
    },
    showCallToBookAsSold: {
      type: Boolean,
      default: false,
    },
    showDuration: {
      type: Boolean,
      default: false,
    },
    showPlayers: {
      type: Boolean,
      default: false,
    },
    deploymentBgClass: {
      type: String,
    },
    bookingLabelStateLocked: {
      type: String,
      default: 'Reserved',
    },
    bookingLabelStateBooked: {
      type: String,
      default: 'Sold',
    },
  },

  data() {
    return {
      today: moment().startOf('day'),
      now: moment(),

      cart: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialCart))),
    };
  },

  computed: {
    dateRangeStart() {
      return this.date.clone().startOf('isoWeek');
    },

    dateRange() {
      let weekofDays = [];
      for (var i = 0; i < 7; i++) {
        weekofDays.push(moment(this.dateRangeStart).add(i, 'days'));
      }
      return weekofDays;
    },

    room() {
      return this.location.rooms.find(r => r.id == this.bookingRoomId);
    },

    roomSlotsForRoom() {
      let roomSlotsForRoom = {};
      for (const [date, roomSlotsForDate] of Object.entries(this.roomSlots)) {
        if (this.mainroomRoomId) {
          roomSlotsForRoom[date] = roomSlotsForDate.filter(roomSlot => roomSlot.room_id == this.mainroomRoomId);
        } else {
          roomSlotsForRoom[date] = roomSlotsForDate.filter(roomSlot => roomSlot.room_id == this.bookingRoomId);
        }
      }

      return roomSlotsForRoom;
    },

    maximumSlotsInAnyDayThisWeekForRoom() {
      // how many rows we need to render
      let maxSlot = 0;

      this.dateRange.forEach(date => {
        if (this.roomSlotsForRoom[date.format('YYYY-MM-DD')]) {
          maxSlot = Math.max(
            maxSlot,
            this.roomSlotsForRoom[date.format('YYYY-MM-DD')].length
          );
        }
      });

      return maxSlot;
    },

    availableRoomSlotsForOtherRooms() {
      let roomSlotsForOtherRooms = {};
      for (const [date, roomSlotsForDate] of Object.entries(this.roomSlots)) {
        if (this.mainroomRoomId) {
          roomSlotsForOtherRooms[date] = roomSlotsForDate.filter(roomSlot => roomSlot.room_id != this.bookingRoomId && roomSlot.room_id != this.mainroomRoomId && roomSlot.state == 'AVAILABLE');
        } else {
          roomSlotsForOtherRooms[date] = roomSlotsForDate.filter(roomSlot => roomSlot.room_id != this.bookingRoomId && roomSlot.state == 'AVAILABLE');
        }
      }

      return roomSlotsForOtherRooms;
    },

    otherRoomsAvailableForWeek() {
      let otherRoomsAvailableForWeek = {};
      let roomIds = {};
      for (const [date, roomSlotsForDate] of Object.entries(this.availableRoomSlotsForOtherRooms)) {
        roomIds[date] = Array.from(new Set(roomSlotsForDate.map(roomSlot => roomSlot.room_id))).sort();
      }

      return roomIds;
    },

    roomSlotIdsInCart() {
      let roomSlotIds = [];

      if (this.cart) {
        this.cart.cart_items.forEach(cartItem => {
          if (cartItem.cartable_type == 'App\\Models\\RoomSlot') {
            roomSlotIds.push(cartItem.cartable_id);
          }
        });
      }

      return roomSlotIds;
    },

    openRooms() {
      return this.location.rooms.filter(room => room.badge != 'SOON');
    },

    todayDateString() {
      return moment().format('YYYY-MM-DD');
    },

    promoDate() {
      if (this.locationDiscount) {
        return moment(this.locationDiscount.date).format('YYYY-MM-DD');
      } else {
        return "N/A";
      }
    },
  },

  watch: {
    initialCart: {
      handler(newCart) {
        // console.log('BookingCalendarSubComponentAllRoomsGrid::watch initialCart', newCart);
        this.cart = newCart;
        // console.log('BookingCalendarSubComponentAllRoomsGrid:: cart now changed');
      },
      deep: true,
    },
    date: {
      handler(newDate, oldDate) {
        if (! oldDate.isSame(newDate, 'week')) {
          this.fetchRoomSlots(newDate);
        }

        this.echoDeInit(oldDate);
        this.echoInit(newDate);
      },
      deep: true,
    },
  },

  methods: {
    changeDate(newDate) {
      this.$emit('date-changed', newDate);
    },

    fetchRoomSlots(newDate) {
      let roomSlotsRequest = {
        for_rooms_for_week: 1,
        room_ids: this.location.rooms.map(room => room.id),
        cart_hash_id: this.cart.hashid,
      };

      if (newDate) {
        roomSlotsRequest.date = newDate.toISOString(true);
      } else {
        roomSlotsRequest.date = this.date.toISOString(true);
      }

      let roomsAvailableRequest = {
        ...roomSlotsRequest,
        availability_only: 1,
        cart_hash_id: this.cart.hashid,
      };

      this.loading(true, this.$refs.calendarContainer);

      Promise.all([
        axios.get(this.route('api.room-slots.index'), {params: roomSlotsRequest}),
        axios.get(this.route('api.room-slots.index'), {params: roomsAvailableRequest})
      ])
        .then(results => {
          const roomSlotsResponse = results[0];
          const roomsAvailableResponse = results[1];

          if (roomSlotsResponse.status == 200 && roomsAvailableResponse.status == 200) {
            this.$emit('publish-room-slots', roomSlotsResponse.data);
            this.$emit('publish-rooms-available', roomsAvailableResponse.data);
          } else {
            flash('Error fetching data.', 'danger');
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.data);
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.status);
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.statusText);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.data);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.status);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error fetching room slots', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('fetchRoomSlots:401', error.response.data);
            }
            console.log('fetchRoomSlots: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('fetchRoomSlots: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('fetchRoomSlots: Error', error.message);
          }

          this.loading(false);
        });
    },

    changeQueryString(param, value) {
      let url = new URL(window.location);
      url.searchParams.set(param, value);
      let state = {[param]: value};
      history.pushState(state, '', url);
    },

    /*
     * END mainCal methods
     * =============== */

    /* ===============
     * timeslotCal methods
     */

    slotClickable(roomSlot) {
      switch (roomSlot.state) {
        case 'LOCKED':
        case 'AVAILABLE':
        case 'BOOKED_PENDING':
        case 'BOOKED_PART':
          return true;
        case 'BOOKED':
        case 'HIDDEN':
        case 'UNSOLD':
        case 'DELETED':
        default:
          return false;
      }
    },

    slotStateClass(roomSlot) {
      switch (roomSlot.state) {
        case 'LOCKED':
        case 'BOOKED_PENDING':
          return 'timeSlotCalLocked';
        case 'BOOKED':
        case 'HIDDEN':
        case 'UNSOLD':
        case 'DELETED':
          return 'timeSlotCalBooked';
        case 'AVAILABLE':
        case 'BOOKED_PART':
          return 'timeSlotCalNotBookedCal';
        default:
          return '';
      }
    },

    slotStateStringForDisplay(roomSlot) {
      switch (roomSlot.state) {
        case 'HIDDEN':
        case 'UNSOLD':
          return 'Booked'
        default:
          return roomSlot.state_string;
      }
    },

    roomFor(roomSlot) {
      return this.location.rooms.find(room => room.id == roomSlot.room_id);
    },

    roomSlotClicked(roomSlot) {
      console.log('BookingCalendarSubComponentRoomWeekGrid::roomSlotClicked', roomSlot);

      if (this.slotClickable(roomSlot) === false) {
        return false;
      }
      if (this.checkCallToBook(roomSlot)) {
        if (this.showCallToBookAsSold) {
          // do nothing
        } else {
          this.$emit('show-call-to-book', roomSlot);
          console.log('emitted show-call-to-book RoomSlot');
        }
      } else {
        if ('LOCKED' == roomSlot.state || 'BOOKED_PENDING' == roomSlot.state) {
          this.$emit('attempt-to-unlock-slot', roomSlot);
          console.log('emitted attempt-to-unlock-slot RoomSlot');
        } else {
          this.$emit('add-room-slot-to-pre-cart', roomSlot);
          console.log('emitted add-room-slot-to-pre-cart RoomSlot');
        }
      }
    },

    checkCallToBook(roomSlot) {
      return moment(roomSlot.start).subtract(this.location.booking_minutes, 'minutes') < moment() || roomSlot.call_to_book != 'NO';
    },

    openModalRoomSlotNotAvailable() {
      // console.log('openModalRoomSlotNotAvailable()');
      this.$refs.makeBooking.hideAllModals();
      this.$refs.roomSlotUnavailable.showModal();
    },

    calendarCell(formattedDate, roomSlotIndex) {
      var theClass = '';
      var theText = '';
                        // roomSlotIdsInCart.includes(roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex].id) ? 'inCart' :
                        //   ! showCallToBookAsSold && roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex].state == 'AVAILABLE' ? (checkCallToBook(roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex]) ? 'calendarWeekGrid_bg_available_c2b' : 'calendarWeekGrid_bg_available') :
                        //     (roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex].state == 'LOCKED' ? 'calendarWeekGrid_bg_locked' :
                        //        showCallToBookAsSold && roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex].state == 'AVAILABLE' && ! checkCallToBook(roomSlotsForRoom[date.format('YYYY-MM-DD')][roomSlotIndex]) ? 'calendarWeekGrid_bg_available' : 'calendarWeekGrid_bg_booked')"
      if (this.roomSlotIdsInCart.includes(this.roomSlotsForRoom[formattedDate][roomSlotIndex].id)) {
        theClass = 'inCart';
        theText = 'In Cart';
      } else if (this.roomSlotsForRoom[formattedDate][roomSlotIndex].state == 'AVAILABLE') {
        if (this.checkCallToBook(this.roomSlotsForRoom[formattedDate][roomSlotIndex])) {
          if (this.showCallToBookAsSold) {
            theClass = 'calendarWeekGrid_bg_booked';
            theText = '&nbsp;' + this.bookingLabelStateBooked + '&nbsp;';
          } else {
            theClass = 'calendarWeekGrid_bg_available_c2b';
            theText = this.location.booking_options.c2b_calendar_title;
          }
        } else {
          theClass = 'calendarWeekGrid_bg_available';
          if (this.roomSlotsForRoom[formattedDate][roomSlotIndex].public_booking) {
            theText = this.roomSlotsForRoom[formattedDate][roomSlotIndex].availableRemainingTickets + '/' + (this.roomSlotsForRoom[formattedDate][roomSlotIndex].override_play_max ? this.roomSlotsForRoom[formattedDate][roomSlotIndex].override_play_max : this.location.rooms.find(r => r.id == this.roomSlotsForRoom[formattedDate][roomSlotIndex].room_id).play_max) + ' Available';
          } else {
            theText = 'Available';
          }
        }
      } else if (this.roomSlotsForRoom[formattedDate][roomSlotIndex].state == 'LOCKED' || this.roomSlotsForRoom[formattedDate][roomSlotIndex].state == 'BOOKED_PENDING') {
        theClass = 'calendarWeekGrid_bg_locked';
        theText = this.bookingLabelStateLocked;
      } else if (this.roomSlotsForRoom[formattedDate][roomSlotIndex].state == 'BOOKED_PART') {
        theClass = 'calendarWeekGrid_bg_available_part';
        theText = this.roomSlotsForRoom[formattedDate][roomSlotIndex].availableRemainingTickets + '/' + (this.roomSlotsForRoom[formattedDate][roomSlotIndex].override_play_max ? this.roomSlotsForRoom[formattedDate][roomSlotIndex].override_play_max : this.location.rooms.find(r => r.id == this.roomSlotsForRoom[formattedDate][roomSlotIndex].room_id).play_max) + ' Available';
      } else {
        theClass = 'calendarWeekGrid_bg_booked';
        theText = this.bookingLabelStateBooked;
      }
      return {
        class: theClass,
        text: theText,
      };
    },

    allRoomsClicked(room) {
      console.log('BookingCalendarSubComponentRoomWeekGrid::allRoomsClicked', room);
      // probably want a bool Meta|Option here to state what to do for the calendar
      // Option 1) change this iFrame view to that Room
      // Option 2) redirect to that page
      // TODO: the below if statement
      if (true) {
        this.$emit('differing-calendar-clicked', null);
      } else {
        window.location.href = locationRoomRoute(room.id, this.date.format('YYYY-MM-DD')) + '#book';
      }
    },

    otherRoomClicked(room) {
      console.log('BookingCalendarSubComponentAllRoomsGrid::otherRoomClicked', room);
      // probably want a bool Meta|Option here to state what to do for the calendar
      // Option 1) change this iFrame view to that Room
      // Option 2) redirect to that page
      // TODO: the below if statement
      if (true) {
        this.$emit('differing-calendar-clicked', room);
      } else {
        window.location.href = locationRoomRoute(room.id, this.date.format('YYYY-MM-DD')) + '#book';
      }
    },

    /*
     * END timeslotCal methods
     * =============== */

    /* ===============
     * Echo methods
     */
    echoInit(date) {
      // console.log('echoInit(date)', date);
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('booking-calendar.room-slots.' + date.format('YYYY-MM'))
        .listen('BookingCalendar.RoomSlotChanged', this.roomSlotChangedEvent)
        .listen('BookingCalendar.RoomSlotDeleted', this.roomSlotDeletedEvent);
    },

    echoDeInit(date) {
      // console.log('echoDeInit(date)', date);
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('room-slots.' + date.format('YYYY-MM'));
    },

    roomSlotChangedEvent(event) {
      // console.log('roomSlotChangedEvent(event)', event);
      let roomSlotDate = moment(event.roomSlot.start).format('YYYY-MM-DD');
      if (! this.roomSlots.hasOwnProperty(roomSlotDate)) {
        return;
      }

      let roomSlotIndex = this.roomSlots[roomSlotDate].findIndex(rs => rs.id == event.roomSlot.id);
      if (roomSlotIndex == -1) {
        return;
      }

      this.$set(this.roomSlots[roomSlotDate], roomSlotIndex, event.roomSlot);
    },

    roomSlotDeletedEvent(event) {
      // console.log('roomSlotDeletedEvent(event)', event);
      let roomSlotDate = moment(event.roomSlot.start).format('YYYY-MM-DD');
      if (! this.roomSlots.hasOwnProperty(roomSlotDate)) {
        return;
      }

      let roomSlotIndex = this.roomSlots[roomSlotDate].findIndex(rs => rs.id == event.roomSlot.id);
      if (roomSlotIndex == -1) {
        return;
      }

      this.$delete(this.roomSlots[roomSlotDate], roomSlotIndex);
    },

    echoInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('cart.session.' + this.cart.session)
        .listen('Cart.CartSaved', this.cartSavedEvent);

      Echo.channel('booking-calendar.cart.session.' + this.cart.session)
        .listen('BookingCalendar.VirtualRoomSlotAvailabilityForCart', this.virtualRoomSlotAvailabilityForCartEvent);
    },

    echoDeInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('cart.session.' + this.cart.session);
      Echo.leave('booking-calendar.cart.session.' + this.cart.session)
    },

    cartSavedEvent(event) {
      // console.log('cartSavedEvent(event)', event);
      this.cart = event.cart;
    },

    virtualRoomSlotAvailabilityForCartEvent(event) {
      // console.log('virtualRoomSlotAvailabilityForCartEvent(event) @ ' + moment().format('HH:mm'), event);
      if (this.roomSlots[event.date]) {
        this.$set(this.roomSlots, event.date, event.roomSlots);
      }
    },

    /*
     * END Echo methods
     * =============== */

    locationRoomRoute(room_id, date) {
      let room = this.location.rooms.find(room => room.id == room_id);

      return this.route(this.location.locationRoomRoute, {location: this.location, room: room, dt: date});
    },

    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },

  },

  mounted() {
    if (this.dateRange[6].isSame(this.dateRange[0], 'month')) {
      // only subscribe to current month
      // console.log('subscribe to', this.dateRange[0].format('YYYY-MM-DD'));
      this.echoInit(this.dateRange[0]);
    } else {
      // subscribe to both months
      // console.log('subscribe to', this.dateRange[0].format('YYYY-MM-DD'));
      this.echoInit(this.dateRange[0]);
      // console.log('subscribe to', this.dateRange[6].format('YYYY-MM-DD'));
      this.echoInit(this.dateRange[6]);
    }

    this.$nextTick(() => {
      this.echoInitCart();
    });
  },

  beforeDestroy() {
    if (this.dateRange[6].isSame(this.dateRange[0], 'month')) {
      // only subscribe to current month
      // console.log('subscribe to', this.dateRange[0].format('YYYY-MM-DD'));
      this.echoDeInit(this.dateRange[0]);
    } else {
      // subscribe to both months
      // console.log('subscribe to', this.dateRange[0].format('YYYY-MM-DD'));
      this.echoDeInit(this.dateRange[0]);
      // console.log('subscribe to', this.dateRange[6].format('YYYY-MM-DD'));
      this.echoDeInit(this.dateRange[6]);
    }

    this.echoDeInitCart();
  },
}
</script>
